import { RootState } from 'redux/types';

export const getPatientId = (store: RootState): string => store.user.patientId;
